import { DevelopingModal } from "components/modal";
import SendOTPModal from "components/verification/SendOTPModal";
import { ReactNode, useCallback, useEffect } from "react";
import { AlertState, closeAlert, toggleAlert } from "state/alert/alertSlice";
import { useAppDispatch, useAppSelector } from "state/hooks";
import Swal, { SweetAlertOptions } from "sweetalert2";

const AlertProvider = ({ children }: { children: ReactNode }) => {
  const dispatch = useAppDispatch();
  const alert = useAppSelector((state) => state.alert);

  const configAlertOptions = useCallback((alert: AlertState) => {
    let config: SweetAlertOptions = alert;
    let { isOpen, onConfirm, onCancel, type, content, ...sweetAlertConfigs } = alert;
    switch (alert.type) {
      case "success":
        config = {
          ...sweetAlertConfigs,
          icon: "success",
        };
        break;
      case "error":
        config = {
          ...sweetAlertConfigs,
          icon: "error",
        };
        break;
      case "warning":
        config = {
          ...sweetAlertConfigs,
          icon: "warning",
        };
        break;
    }

    return {
      ...config,
      html: content,
      reverseButtons: true,
      cancelButtonText: "Hủy bỏ",
      confirmButtonText: "Xác nhận",
    };
  }, []);

  const renderCustomAlert = useCallback(() => {
    switch (alert.type) {
      case "verify":
        return (
          <SendOTPModal
            title={alert.title}
            content={alert.content}
            isOpen={alert.isOpen}
            onChange={() => {
              dispatch(closeAlert());
            }}
            onConfirm={() => {
              alert.onConfirm && alert.onConfirm();
            }}
          />
        );
      case "develop":
        return (
          <DevelopingModal
            isOpen={alert.isOpen}
            onChange={() => {
              dispatch(
                toggleAlert({
                  type: "develop",
                  title: alert.title,
                  content: alert.content,
                }),
              );
            }}
            title={alert.title}
            content={alert.content}
          />
        );
      default:
        return null;
    }
  }, [alert, dispatch]);

  useEffect(() => {
    async function fireNotificationAlert() {
      const result = await Swal.fire(configAlertOptions(alert));
      if (result.isConfirmed && alert.onConfirm) {
        alert.onConfirm();
      } else if (result.isDismissed && alert.onCancel) {
        alert.onCancel();
      }
    }

    if (alert.isOpen) {
      if (["success", "error", "warning"].includes(alert.type)) fireNotificationAlert();
    }
  }, [alert, configAlertOptions, renderCustomAlert]);

  useEffect(() => {
    return () => {
      dispatch(closeAlert());
    };
  }, [dispatch]);

  return (
    <>
      {renderCustomAlert()}
      {children}
    </>
  );
};

export default AlertProvider;
